import React, { useState, useEffect } from "react";
import { SlidersHorizontal } from "lucide-react";
import { useI18n } from "../../i18n";
import { api, apiError } from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

const NAVY = "hsl(217_63%_15%)";
const SEV = ["high", "medium", "low"];

export default function RulesAdmin() {
  const { t, lang } = useI18n();
  const [rules, setRules] = useState([]);
  const load = () => api.get("/control/rules").then((r) => setRules(r.data || [])).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);

  const patch = async (id, fields) => {
    try { await api.put(`/control/rules/${id}`, fields); toast.success(t("rules_updated")); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div className="space-y-5 gc-fade-up" data-testid="rules-admin">
      <div className="flex items-start gap-3">
        <div className="h-10 w-10 rounded-xl flex items-center justify-center shrink-0" style={{ backgroundColor: NAVY }}><SlidersHorizontal className="h-5 w-5 text-white" /></div>
        <div>
          <h1 className="font-display text-2xl font-bold" style={{ color: NAVY }}>{t("rules_title")}</h1>
          <p className="text-sm text-muted-foreground mt-1">{t("rules_sub")}</p>
        </div>
      </div>
      <div className="rounded-2xl border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-muted-foreground text-xs border-b border-border">
            <th className="text-start p-3">{t("rule_col_id")}</th>
            <th className="text-start p-3">{t("rule_col_name")}</th>
            <th className="text-start p-3">{t("rule_col_cat")}</th>
            <th className="text-start p-3">{t("rule_col_sev")}</th>
            <th className="text-center p-3">{t("rule_col_ver")}</th>
            <th className="text-center p-3">{t("rule_col_on")}</th>
          </tr></thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id} data-testid={`rule-row-${r.rule_key}`} className="border-b border-border">
                <td className="p-3 font-mono text-xs">{r.rule_id}</td>
                <td className="p-3">{lang === "ar" ? r.name_ar : r.name_en}</td>
                <td className="p-3 text-muted-foreground text-xs">{r.category}</td>
                <td className="p-3">
                  <Select value={r.severity} onValueChange={(v) => patch(r.id, { severity: v })}>
                    <SelectTrigger data-testid={`rule-sev-${r.rule_key}`} className="h-8 w-28 text-xs"><SelectValue /></SelectTrigger>
                    <SelectContent>{SEV.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                  </Select>
                </td>
                <td className="p-3 text-center text-xs text-muted-foreground">v{r.version}</td>
                <td className="p-3 text-center">
                  <Button data-testid={`rule-toggle-${r.rule_key}`} onClick={() => patch(r.id, { enabled: !r.enabled })}
                    variant={r.enabled ? "default" : "outline"} className="h-7 rounded-full text-[11px] px-3"
                    style={r.enabled ? { backgroundColor: "hsl(158 64% 28%)" } : {}}>
                    {r.enabled ? t("rule_enable") : t("rule_disable")}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
